import React from 'react';
import * as cls from './what-residents-see.module.css';
import { IMG_PATH } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';

const items = [
  {
    title: 'Clear bill breakdowns',
    text: 'Understand where electricity spend goes (heating, cooking, laundry, EV, etc.).',
  },
  {
    title: 'Standby alerts',
    text: 'Spot “always-on” loads and their yearly cost.',
  },
  {
    title: 'Weekly reports & tips',
    text: 'Personalised, practical ways to cut waste.',
  },
  {
    title: 'Peace of mind',
    text: 'Optional safety-related signals and unusual-usage nudges.',
  },
  {
    title: 'No habit change required',
    text: 'Insights arrive automatically; act when you’re ready.',
  },
];

export const WhatResidentsSee = () => {
  return (
    <Section classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        What Residents See (Customer Value)
      </Typography>

      <div className={cls.wrapper}>
        <ul className={cls.list}>
          {items.map((item, index) => (
            <li key={index}>
              <Typography>{item.title}</Typography>
              <Typography>{item.text}</Typography>
            </li>
          ))}
        </ul>
        <div>
          <img
            alt=""
            src={`${IMG_PATH}/our-technology/hardware/what-residents-see.png`}
          />
        </div>
      </div>
    </Section>
  );
};
